import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BannerCaption.css';
import cx from 'classnames';
import Loader from '../../Loader';
import getLocalizedContent from '../../../core/helpers/getLocalizedContent';

class BannerCaption extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getBanner: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        content: PropTypes.string,
      }),
    }),
    locale: PropTypes.string,
  };

  render() {
    const { data: { loading, getBanner }, locale } = this.props;

    if (loading || !getBanner) {
      return <Loader type={"text"} />
    } else {
      // Get localized content
      const title = getLocalizedContent(getBanner, 'title', locale);
      const content = getLocalizedContent(getBanner, 'content', locale);
      
      return (
        <div className={cx(s.bannerCaptionContainer)}>
          <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
            {title}
            {' '} {content}
          </h1>
        </div>
      );
    }
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

export default connect(mapState)(withStyles(s)(BannerCaption));